import React, { useState } from 'react'
import {
    PanelBody,
    PanelRow,
    ToggleControl,
    SelectControl,
    TextControl,
} from '@wordpress/components'
import { useBlockEffect, useSmartProp } from '@smartfire/js-block-engine'
import apiFetch from '@wordpress/api-fetch'

type selectOption = {
    value: string
    label: string
}

type optGroups = {
    id: number
    label: string
    options: selectOption[]
}

const Inspector = () => {
    const [filter, setFilter] = useSmartProp('filter')
    const [termID, setTermID] = useSmartProp('termID')
    const [link, setLink] = useSmartProp('link')

    const [terms, setTerms] = useState<optGroups[]>([])

    useBlockEffect(() => {
        apiFetch({
            path: 'smartfire/event-category/select-options',
        }).then((data: optGroups[]) => {
            setTerms(Object.values(data))
        })
    }, [])

    return (
        <PanelBody title={'Options'}>
            <PanelRow>
                <ToggleControl
                    label={'Filtrer par une catégorie'}
                    checked={filter}
                    onChange={(value) => {
                        setFilter(value)
                        setTermID(-1)
                    }}
                />
            </PanelRow>
            {filter && (
                <>
                    <PanelRow>
                        <SelectControl
                            label="Filtrer par une catégorie"
                            value={termID}
                            onChange={setTermID}
                        >
                            <option label="Choisir une catégorie..." value={-1} disabled />
                            {terms.map((el) => (
                                <optgroup key={el.id} label={el.label}>
                                    {el.options.map((el) => (
                                        <option key={el.value} value={el.value}>
                                            {el.label}
                                        </option>
                                    ))}
                                </optgroup>
                            ))}
                        </SelectControl>
                    </PanelRow>

                    <PanelRow>
                        <TextControl label='Lien "Voir tous"' value={link} onChange={setLink} />
                    </PanelRow>
                </>
            )}
        </PanelBody>
    )
}

export default Inspector
